import React from "react";
import "./Policies.css";

const CancellationPolicy = () => {
  return (
    <div className="policy-wrapper">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Cancellation & Refund Policy</h1>
          <p>Effective Date: January 1, 2025</p>
        </div>

        <div className="policy-content">
          <p>
            HexaPlay offers various entertainment services including private
            theatre bookings, gaming sessions, VR experiences, and simulator
            sessions. This policy outlines our refund and cancellation terms.
          </p>

          <h2>1. Advance Booking</h2>
          <p>
            Certain services may require an advance payment to reserve a time
            slot.
          </p>

          <h2>2. Cancellation Policy</h2>
          <ul>
            <li>
              Cancellations made at least <strong>72 hours before</strong> the
              scheduled slot are eligible for a full refund (excluding payment
              gateway convenience charges).
            </li>
            <li>
              Cancellations made within <strong>72 hours</strong> of the booking
              time may not be eligible for a refund.
            </li>
          </ul>

          <h2>3. Refund Processing</h2>
          <ul>
            <li>Approved refunds will be initiated within 24 hours.</li>
            <li>
              Refunds will be completed within <strong>3–5 business days</strong>{" "}
              depending on the payment provider.
            </li>
          </ul>

          <h2>4. Non-Refundable Cases</h2>
          <ul>
            <li>No-show for the booking</li>
            <li>Late cancellations</li>
            <li>Violation of venue or equipment usage rules</li>
            <li>Damage caused to gaming equipment or property</li>
          </ul>

          <h2>5. Force Majeure</h2>
          <p>
            In the event of natural disasters or government restrictions,
            HexaPlay will offer alternative dates or credit.
          </p>

          <h2>6. How to Cancel</h2>
          <p>
            Please contact support@hexaplay.com with your booking ID to request
            cancellation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;